import { useTheme } from "arkh";
import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { HeaderButton } from "../../../components";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { StorecastShowFileNavigator } from "./StorecastShowFileNavigator";
import { StorecastShowFileScreen } from "./StorecastShowFileScreen";
import { StorecastShowFileAllFiles } from "./StorecastShowFileAllFiles";
import { StorecastShowFileContext } from "./StorecastShowFileContext";
import { openFileType } from "../useOpenFile";

import { graphql, useMutation } from "react-relay";
import { StorecastShowFileFocusClearFilePageMutation } from "./__generated__/StorecastShowFileFocusClearFilePageMutation.graphql";

type StorecastShowFileProps = {
  route: UserLoggedInNavigatorRouteProp<"StorecastShowFile">;
  navigation: UserLoggedInNavigatorNavigationProp<"StorecastShowFile">;
};

export function StorecastShowFile(props: StorecastShowFileProps) {
  const [clearFocus] = useMutation<StorecastShowFileFocusClearFilePageMutation>(
    graphql`
      mutation StorecastShowFileFocusClearFilePageMutation($storecastId: ID!) {
        dashboard(dashboardId: $storecastId) {
          endFocus {
            focusedNodeId
          }
        }
      }
    `
  );

  const onClearFocus = useCallback(() => {
    clearFocus({ variables: { storecastId: props.route.params.storecastId } });
  }, [clearFocus, props.route.params.storecastId]);

  const openFile: openFileType = useCallback(
    async ({ fileId }) => {
      props.navigation.navigateDeprecated("FileFocus", {
        fileId,
        storecastId: props.route.params.storecastId,
      });
    },
    [props.navigation, props.route.params.storecastId]
  );

  const headerLeft = useCallback(
    () => (
      <HeaderButton
        type="CANCEL"
        onPress={() => {
          onClearFocus();
          props.navigation.goBack();
        }}
      />
    ),
    [onClearFocus, props.navigation]
  );
  const theme = useTheme();
  const intl = useIntl();
  return (
    <StorecastShowFileContext.Provider value={{ openFile }}>
      <StorecastShowFileNavigator.Navigator
        screenOptions={{
          headerStyle: {
            backgroundColor: theme.background,
          },
          headerShadowVisible: false,
          headerShown: true,
        }}
      >
        <StorecastShowFileNavigator.Screen
          name="StorecastShowFileScreen"
          component={StorecastShowFileScreen}
          options={{
            headerLeft,
            title: "Visa fil på Storecast",
            headerTitleAlign: "center",
            animationTypeForReplace: "pop",
          }}
        />
        <StorecastShowFileNavigator.Screen
          name="StorecastShowFileAllFiles"
          component={StorecastShowFileAllFiles}
          options={{
            presentation: "card",
            animationTypeForReplace: "pop",
            title: intl.formatMessage({
              defaultMessage: "All Files",
              description: "All Files navigation header 2",
            }),
            headerStyle: {
              backgroundColor: theme.surface,
            },
          }}
        />
      </StorecastShowFileNavigator.Navigator>
    </StorecastShowFileContext.Provider>
  );
}
